"use client";

import { useEffect } from 'react'; // Impor useEffect
import { Header } from "@/components/header";
import { HeroSection } from "@/components/hero-section";
import { FeaturesSection } from "@/components/features-section";
import { AppShowcaseSection } from "@/components/app-showcase-section";
import { UseCasesSection } from "@/components/use-cases-section";
import { FinalCtaSection } from "@/components/final-cta-section";

export default function HomePage() {
  
  // --- KODE UNTUK MENGHILANGKAN BADGE "MADE WITH CREATR" ---
  useEffect(() => {
    // Metode 1: Injeksi CSS untuk menyembunyikan elemen secara paksa dan segera
    const style = document.createElement('style');
    style.innerHTML = `
      a.creatr-brand-fixed {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
    `;
    document.head.appendChild(style);

    // Metode 2: Mengawasi halaman dan secara otomatis "mengklik" tombol close jika muncul
    const closeButtonClass = 'creatr-branding-close'; 
    const badgeClass = 'creatr-brand-fixed';

    const observer = new MutationObserver((mutationsList, observer) => {
      const closeButton = document.querySelector(`.${closeButtonClass}`) as HTMLElement;
      const badge = document.querySelector(`.${badgeClass}`) as HTMLElement;

      if (closeButton) {
        // Jika tombol close ditemukan, klik tombol tersebut.
        closeButton.click();
        
        // Hentikan pengawasan setelah tugas selesai untuk efisiensi.
        observer.disconnect();
      } else if (badge) {
        // Fallback jika hanya badge yang ditemukan tanpa tombol close
        badge.style.display = 'none';
      }
    });

    // Mulai mengamati perubahan pada body dokumen
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Cleanup: hapus style dan hentikan observer saat komponen tidak lagi digunakan
    return () => {
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
      observer.disconnect();
    };
  }, []); // Dependency array kosong `[]` memastikan efek ini hanya berjalan sekali

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <AppShowcaseSection />
        <UseCasesSection />
        <FinalCtaSection />
      </main>
    </div>
  );
}
